import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-no-interruption-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfNoInterruptionIconProps extends SvgIconProps  {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfNoInterruptionIcon(props: CcfNoInterruptionIconProps) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="30"
      viewBox="0 0 20 30"
      fill="none"
    >
      <path
        d="M19.8982 9.89942C19.8049 9.64376 19.6539 9.42423 19.462 9.26549C19.2701 9.10675 19.0449 9.01509 18.8118 9.0008H13.0581L14.6557 1.89223C14.7059 1.67028 14.7128 1.43752 14.6757 1.21192C14.6386 0.986323 14.5587 0.773922 14.442 0.591127C14.3253 0.408331 14.175 0.260034 14.0027 0.15769C13.8304 0.055346 13.6408 0.00169438 13.4484 0.000879712H4.66145C4.37805 -0.01072 4.09972 0.0926786 3.87178 0.294235C3.64384 0.495791 3.47973 0.783629 3.40617 1.11087L0.0431739 16.1107C-0.00704444 16.3336 -0.0135503 16.5673 0.0241625 16.7936C0.0618752 17.02 0.142789 17.2329 0.260608 17.4158C0.378426 17.5986 0.529971 17.7466 0.703447 17.848C0.876924 17.9495 1.06765 18.0017 1.26079 18.0007H6.11757L3.84666 28.1052C3.77222 28.4312 3.79208 28.7777 3.90302 29.0885C4.01397 29.3993 4.2095 29.6563 4.45793 29.8177C4.70636 29.9792 4.99313 30.0357 5.27178 29.978C5.55043 29.9204 5.80462 29.752 5.99318 29.5001L19.6734 11.5003C19.8355 11.2874 19.9428 11.0232 19.9827 10.7393C20.0226 10.4555 19.9932 10.1639 19.8982 9.89942ZM7.61134 22.9098L8.95449 16.9098C9.00443 16.6882 9.01115 16.4558 8.97411 16.2306C8.93708 16.0054 8.85728 15.7933 8.74088 15.6107C8.62447 15.4282 8.47455 15.2799 8.30266 15.1775C8.13077 15.0751 7.9415 15.0211 7.74942 15.0198H2.93031L5.6166 3.00085H11.804L10.2063 10.1094C10.1552 10.336 10.1492 10.5738 10.1889 10.8036C10.2286 11.0335 10.3129 11.249 10.435 11.4328C10.5571 11.6166 10.7136 11.7637 10.8919 11.8621C11.0702 11.9605 11.2653 12.0075 11.4616 11.9994H15.9418L7.61134 22.9098Z"
        fill="#007AB8"
      />
    </SvgIcon>
  );
}

export default CcfNoInterruptionIcon;
